const normalizedAttributeName = (value) => String(value || '').trim().toLowerCase();

export function isAssignedAttributeGroup(group) {
    return group?.group_kind === 'assigned';
}

export function isWatchlistGroupingAttribute(definition) {
    if (definition?.attribute_definition_id == null) return false;
    if (definition.source_kind === 'user') return true;
    return ![
        normalizedAttributeName(definition.display_name_key),
        normalizedAttributeName(definition.display_name),
    ].includes('quantity');
}
